import { useCallback, useState } from 'react'
import Sockjs from 'sockjs-client'
import Stomp from 'stompjs'

export default function useSocket(accountId) {
  const [socketResponse, setSocketResponse] = useState(null)
  const [messageRecived, setSuccess] = useState(false)

  const sendMessage = useCallback(
    ({ channel, message, payload }, onError) => {
      const socket = new Sockjs(
        // ('http://10.0.0.103:8082/medsis-connect', {
        'http://127.0.0.1:8082/medsis-connect',
        {
          sessionId: () => accountId || Math.random(500),
          timeout: 1000000 * 5
        }
      )
      const client = Stomp.over(socket)
      client.reconnect_delay = 5000

      const handleError = () => {
        console.log('socker error')
        if (onError) {
          return onError(
            'Não possivel estabelecer uma conexão com o Medsis-Connect'
          )
        }
        return Promise.reject(
          'Não possivel estabelecer uma conexão com o Medsis-Connect'
        )
      }

      const handleMessage = () => {

        client.subscribe(channel, response => {
          setSocketResponse(JSON.parse(response.body))
          setSuccess(true)
          client.disconnect()
        })

        if (payload) {
          client.send(message, {}, JSON.stringify(payload))
        } else {
          client.send(message, {})
        }
      }

      client.connect({}, handleMessage, handleError)
    },
    [accountId]
  )

  return {
    socketResponse,
    sendMessage,
    messageRecived
  }
}
